import { isValidElement } from 'react';
const reactNodeToString = reactNode => {
  if (typeof reactNode === 'string') {
    return reactNode;
  }
  if (typeof reactNode === 'number') {
    return reactNode.toString();
  }
  if (Array.isArray(reactNode)) {
    return reactNode.map(reactNodeToString).join(' ');
  }
  if ( /*#__PURE__*/isValidElement(reactNode)) {
    return reactNodeToString(reactNode.props.children);
  }
  return '';
};
export const defaultLabelGetter = item => {
  return item ? reactNodeToString(item.label) : '';
};
const defaultFilterBy = (item, inputValue) => item.includes(inputValue);
export const defaultGetFilteredItems = _ref => {
  let {
    allItems,
    itemToString,
    inputValue,
    filterBy = defaultFilterBy
  } = _ref;
  if (!inputValue) {
    return allItems;
  }
  return allItems.filter(item => filterBy(itemToString(item).toLowerCase(), inputValue.toLowerCase()));
};
export const defaultIsItemDisabled = item => !!item.disabled;
//# sourceMappingURL=defaultGetters.js.map